import { useMemo } from 'react'
import type { InnerForcesEnvelopeDTO } from '@api/fastAPI.schemas'
import { InnerForcesEnvelopeMesh } from '@editor/pages/Results2/components/Results2Scene/components'
import type { EnvelopeComponent } from '@editor/pages/Results2/components/Results2Scene/components/InnerForcesEnvelopeMesh/utils'
import { useSceneElement } from '@editorHooks'

interface Props {
  envelope: InnerForcesEnvelopeDTO
  component: EnvelopeComponent
}

/** Shows the inner forces envelope in the scene for as long as this component is mounted. */
const InnerForcesEnvelopeSceneEffect = ({ envelope, component }: Props): null => {
  const properties = useMemo(() => ({ envelope, component }), [envelope, component])
  useSceneElement({ enabled: true, properties, component: InnerForcesEnvelopeMesh })
  return null
}

export default InnerForcesEnvelopeSceneEffect
